/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  permits: [],
  limit: 5,
  keywordFilter: '',
};

const getters = {
  permits: state => state.permits,
  limit: state => state.limit,
  keywordFilter: state => state.keywordFilter,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    let keyword = '';
    if (payload.keyword) {
      commit(mTypes.SET_KEYWORD_FILTER, payload.keyword);
      keyword = `&q=${payload.keyword}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/permits/list?${keyword}${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch permits');
      });
  },
  fetchUserPermits({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    let keyword = '';
    if (payload.keyword) {
      keyword = `&q=${payload.keyword}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/users/${payload.userId}/permits/list?${keyword}${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch permits');
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, permits) {
    state.permits = permits.data;
  },
  [mTypes.EDIT_DATA](state, updatedPermit) {
    const index = state.permits.items.findIndex(obj =>
      obj.id === updatedPermit.id,
    );
    if (index !== -1) {
      // state.permits.items.[index] = updatedPermit;
      Vue.set(state.permits.items, index, updatedPermit);
    } else {
      state.permits.items.unshift(updatedPermit);
    }
  },
  [mTypes.CLEAR_STATE](state) {
    state.permits = {};
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.REMOVE_DATA](state, permitId) {
    const index = state.permits.items.findIndex(obj => obj.id === permitId);
    state.permits.items.splice(index, 1);
    state.permits.total -= 1;
  },
  [mTypes.REMOVE_DATAS](state, ids) {
    const items = state.permits.items.filter((obj) => {
      const findItem = ids.find(id => id === obj.id);

      if (findItem) return false;
      return true;
    });

    state.permits.items = items;
  },
  [mTypes.SET_KEYWORD_FILTER](state, keywordFilter) {
    state.keywordFilter = keywordFilter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/permits.js